<style>
#DataAttributionsTable .container {
  padding: 0px;
  max-height: 30vh;
}
/*  #DataAttributionsTable-scroll {

  } */

#DataAttributionsTable .container .v-datatable tr {
  padding-bottom: 0px;
  margin-bottom: 0px;
  line-height: 1;
  height: 40px;
}
/* #DataAttributionsTable .container .v-datatable th {

  }  */
#DataAttributionsTable .container .v-datatable td {
  height: 10px;
}
/* .v-menu__content {
  z-index: 1000 !important;
} */
#DataAttributionsTable .v-text-field__slot label,
#DataAttributionsTable .v-text-field__slot input,
#DataAttributionsTable
  > div.v-card__title
  > div.v-input.v-text-field.v-text-field--placeholder {
  font-size: 12px;
}
#DataAttributionsTable .row--center {
  text-align: center;
}
#DataAttributionsTable-scroll div.v-input__slot div.v-select__slot label {
  font-size: 12px !important;
}
#DataAttributionsTable-scroll .v-icon {
  font-size: 18px !important;
  color: rgba(0, 0, 0, 0.54) !important;
  padding-right: 8px;
}
#DataAttributionsTable-scroll .v-input {
  font-size: inherit !important;
}
#DataAttributionsTable-scroll td {
  line-height: 40px;
}
#DataAttributionsTable .container .v-table__overflow {
  width: fit-content;
  width: -moz-fit-content;
}
#DataAttributionsTable-scroll td.justify-center.layout.px-0 i {
  position: relative;
  top: 5px;
}
</style>

<template>
  <!--<div class="text-xs-center">-->
  <v-bottom-sheet v-model="show" hide-overlay persistent full-width>
    <ExportTableData
      ref="pobierz"
      type-source="attr-table"
      :filtred-items="elementsExport"
      :srid="srid"
      :projection="$root.projection"
      :fields="fields"
    ></ExportTableData>
    <v-card id="DataAttributionsTable" ref="card">
      <resize-observer @notify="onResize"></resize-observer>
      <v-card-title>
        <VBtnGroup>
          <v-tooltip bottom>
            <template slot="activator">
              <v-btn flat @click="filterActive = !filterActive" :input-value="filterActive">
                <v-icon small>filter_list</v-icon>
              </v-btn>
            </template>
            <span class="font--primary">Filtrowanie po kolumnach</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template slot="activator">
              <v-btn flat v-if="countFiltresSelected > 0" color="error" @click="clearFilters">
                <v-icon>clear</v-icon>
              </v-btn>
            </template>
            <span class="font--primary">Wyczyść filtrowanie</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template slot="activator">
              <v-btn
                flat
                @click="filterExtentActive = !filterExtentActive"
                :input-value="filterExtentActive"
              >
                <v-icon>fullscreen</v-icon>
              </v-btn>
            </template>
            <span class="font--primary">Filtrowanie po zasięgu</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template slot="activator">
              <v-btn flat @click="editSelectrdItems" :disabled="selected.length < 1 || !edition">
                <v-icon>edit</v-icon>
              </v-btn>
            </template>
            <span class="font--primary">Edytuj zaznaczone</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template slot="activator">
              <v-btn
                flat
                @click="filterSelectedActive = !filterSelectedActive"
                :input-value="filterSelectedActive"
              >
                <v-icon>select_all</v-icon>
              </v-btn>
            </template>
            <span class="font--primary">Filtrowanie zaznaczonych</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template slot="activator">
              <v-btn flat @click="exportItems($event)">
                <v-icon>cloud_download</v-icon>
              </v-btn>
            </template>
            <span class="font--primary">Pobierz</span>
          </v-tooltip>
          <v-tooltip bottom v-if="geometry_type == 'none'">
            <template slot="activator">
              <v-btn flat @click="addNewFeature" :disabled="!edition">
                <v-icon>add_circle</v-icon>
              </v-btn>
            </template>
            <span class="font--primary">Dodaj</span>
          </v-tooltip>
        </VBtnGroup>
        <span class="font--primary">
          Liczba wybranych elementów:
          <span v-text="selected.length"></span> /
          <span v-text="filtredItems.length"></span>
        </span>
        <v-spacer></v-spacer>
        <v-text-field
          :disabled="disabledButtons"
          v-model="search"
          append-icon="search"
          label="Szukaj"
          single-line
          hide-details
          style="padding-top:0;margin-top:-8px;max-width:300px;"
        ></v-text-field>
        <v-tooltip bottom>
          <template slot="activator">
            <v-btn @click="closePanel" color="red" dark icon flat>
              <v-icon dark>clear</v-icon>
            </v-btn>
          </template>
          <span class="font--primary">Zamknij panel</span>
        </v-tooltip>
      </v-card-title>
      <v-container id="DataAttributionsTable-scroll" class="scroll-y" fluid>
        <v-data-table
          v-model="selected"
          item-key="__index"
          :headers="headers"
          :items="filtredItems"
          :pagination.sync="pagination"
          :search="search"
          class="elevation-1"
          select-all
          hide-actions
          v-scroll:#DataAttributionsTable-scroll="onScroll"
        >
          <!--:rows-per-page-items="[25, 50, 100, 200]"-->
          <template slot="no-data">
            <v-alert
              :value="true"
              color="error"
              icon="warning"
              v-if="layerNotLoaded"
            >Brak danych, najpierw wybierz odpowiednią warstwę</v-alert>
            <v-alert
              :value="true"
              color="error"
              icon="warning"
              v-else
            >Brak danych spełniających kryteria filtrowania</v-alert>
          </template>
          <template slot="headers" slot-scope="props">
            <tr>
              <th>
                <v-checkbox
                  :input-value="props.all"
                  :indeterminate="props.indeterminate"
                  primary
                  hide-details
                  @click.stop="toggleAll"
                  style="position:relative;bottom:-5px;"
                ></v-checkbox>
              </th>
              <th v-if="edition">Akcje</th>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                <span v-text="header.text"></span>
              </th>
            </tr>
            <tr v-if="filterActive">
              <th></th>
              <th v-if="edition"></th>
              <th v-for="header in props.headers" :key="header.text">
                <template v-if="header.value == '__index'">
                  <th></th>
                </template>
                <template v-else>
                  <VInputFilter
                    v-model="daneFiltra[header.value]"
                    :type="header.type"
                    :combo="header.combo"
                    :combo-items="header.comboItems"
                  ></VInputFilter>
                </template>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr :active="props.selected" @click="zoomTo(props.item)" style="text-align:center;">
              <td>
                <v-checkbox
                  v-model="props.selected"
                  primary
                  hide-details
                  style="position:relative;bottom:-5px;"
                ></v-checkbox>
              </td>
              <td class="justify-center layout px-0" v-if="edition">
                <v-icon small class="mr-2" @click.stop="editItem(props.item)">edit</v-icon>
                <v-icon small @click.stop="deleteItem(props.item)">delete</v-icon>
              </td>
              <td v-text="props.item.__index"></td>
              <td v-text="props.item.__db_id"></td>
              <td v-for="field in fields">
                <span v-text="props.item[field.name] || ''" style="white-space: nowrap;"></span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="pagination.page"
          v-if="pages > 1"
          :total-visible="pages < 10 ? pages : 10"
          :length="pages"
        ></v-pagination>
      </div>
    </v-card>
  </v-bottom-sheet>
  <!--</div>-->
</template>

<script>
import { Vector as VectorLayer } from "ol/layer";
import { getForViewAndSize } from "ol/extent";
import { GeoJSON } from "ol/format";
import Feature from "ol/Feature";
import { Cluster } from "ol/source";

let formatGeoJSON;

import moment from "moment";
import { saveAs } from "file-saver";

import VBtnGroup from "../components/VBtnGroup";
import VInputFilter from "../components/VInputFilter";
import { ResizeObserver } from "vue-resize";
import "vue-resize/dist/vue-resize.css";
import ExportTableData from "../../../shared/ExportTableData";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
import filter from "lodash/filter";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import some from "lodash/some";
//import isArray from "lodash/isArray";
import each from "lodash/each";

import eq from "lodash/eq";
import lt from "lodash/lt";
import lte from "lodash/lte";
import gt from "lodash/gt";
import gte from "lodash/gte";
import startsWith from "lodash/startsWith";
import endsWith from "lodash/endsWith";
import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";

import keyBy from "lodash/keyBy";
import mapValues from "lodash/mapValues";
mixin(_, {
  map,
  filter,
  includes,
  isEmpty,
  some,
  //isArray,
  each,
  chain,

  eq,
  eqSoft(value, other) {
    return value == other;
  },
  lt,
  lte,
  gt,
  gte,
  startsWith,
  endsWith,
  isNull,
  isUndefined,

  keyBy,
  mapValues
});
_.value = value;
_.prototype.value = value;

export default {
  components: {
    VBtnGroup,
    VInputFilter,
    ExportTableData,
    "resize-observer": ResizeObserver
  },
  data: () => ({
    show: false,
    layerNotLoaded: false,
    disabledButtons: false,

    offsetTop: 0,
    search: "",

    filterActive: false,
    filterExtentActive: false,
    filterSelectedActive: false,

    pagination: {
      sortBy: "index",
      rowsPerPage: 100,
      page: 0
    },
    selected: [],

    editedIndex: -1,
    //editedItem: {},

    daneFiltra: {},
    filtersType: {},
    extent: [],

    headers: [],
    items: [],
    filtredItems: [],
    fields: [],
    geometry_type: "none",

    ignore: false
  }),
  computed: {
    map() {
      return this.$store.getters.getMap;
    },
    currentSelectedFeatures() {
      return this.$store.getters.getCurrentSelectedFeatures;
    },
    selectedLayer() {
      return this.map
        .getLayers()
        .item(3)
        .getLayers()
        .item(0);
    },
    srid() {
      return this.$store.getters.getSrid;
    },

    mapCenter() {
      return this.$store.getters.getMapCenter;
    },
    edition() {
      return this.$store.getters.getEditionOn;
    },
    elementsExport() {
      if (this.selected.length !== 0) {
        return _.map(this.selected, v => v.__instance);
      } else if (this.filtredItems.length !== 0) {
        return _.map(this.filtredItems, v => v.__instance);
      } else {
        return _.map(this.items, v => v.__instance);
      }
    },

    countFiltresSelected() {
      return _.filter(this.daneFiltra, (data, column) => {
        if (_.isEmpty(data)) {
          return false;
        }
        switch (
          _.startsWith(data.type, "not_") ? data.type.substr(4) : data.type
        ) {
          case "eq":
          case "contains":
          case "start_with":
          case "end_with": {
            if (!data.value) {
              return false;
            }
          }
        }

        return true;
      }).length;
    },

    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    currentSelectedFeatures(_new) {
      if (!this.ignore) {
        const selectedItems = _.filter(this.items, item =>
          _.some(_new, feature => feature.getId() === item.__db_id)
        );
        this.ignore = true;
        this.selected = selectedItems;
        if (this.filterSelectedActive) {
          this.updateFilter();
        }
      } else {
        this.ignore = false;
      }
    },
    selected(_new) {
      if (!this.ignore) {
        const selectedFeatures = _.filter(
          this.layer.getSource().getFeatures(),
          feature => _.some(_new, item => item.__db_id === feature.getId())
        );
        this.selectedLayer.getSource().clear(true);
        this.selectedLayer.getSource().addFeatures(selectedFeatures);
        this.ignore = true;
        this.$store.commit(
          "setCurrentSelectedFeatures",
          _.map(selectedFeatures, feature => this.$root.createProxy(feature))
        );
      } else {
        this.ignore = false;
      }
    },

    filterActive(_new) {
      if (!_new) {
        this.daneFiltra = {};
        this.generateFilters();
      }
    },
    filterExtentActive(_new) {
      if (_new) {
        this.extent = this.calculateExtent();
      } else {
        this.extent = [];
      }
      this.updateFilter();
    },
    filterSelectedActive(_new) {
      this.updateFilter();
    },
    daneFiltra: {
      handler(_new, _old) {
        this._computedWatchers.countFiltresSelected.update();
        this.updateFilter();
      },
      deep: true
    },
    mapCenter() {
      if (this.filterExtentActive) {
        this.extent = this.calculateExtent();
        this.updateFilter();
      }
    }
  },
  created() {
    this.layer = false;
    this.$root.$on("openAttributeTableData", this.openAttributeTableData);
    this.$root.$on("closeAttributeTableData", this.closeAttributeTableData);
    this.$root.$on("refreshAttributeTableData", this.refreshAttributeTableData);
    this.$root.$on("changeAttributeTableData", this.changeAttributeTableData);

    moment.locale("pl");
    formatGeoJSON = new GeoJSON({
      dataProjection: this.srid,
      featureProjection: this.$root.projection
    });
  },
  beforeDestroy() {
    this.$root.$off("openAttributeTableData", this.openAttributeTableData);
    this.$root.$off("closeAttributeTableData", this.closeAttributeTableData);
    this.$root.$off(
      "refreshAttributeTableData",
      this.refreshAttributeTableData
    );
    this.$root.$off("changeAttributeTableData", this.changeAttributeTableData);
  },
  methods: {
    changeAttributeTableData(layer) {
      if (this.show) {
        this.openAttributeTableData(layer);
      }
    },
    refreshAttributeTableData() {
      if (this.layer && this.show) {
        this.$root.$emit(
          "showSnackbar",
          "blue",
          "Odświeżanie danych proszę czekać"
        );
        setTimeout(() => {
          this.items = this.generateItems();
          this.generateFilters();
          this.updateFilter();
        }, 500);
      }
    },
    openAttributeTableData(layer) {
      this.fields = layer.get("fields");
      this.layer = layer;
      this.geometry_type = layer.get("geometry_type");
      this.layerNotLoaded = !layer.getVisible();
      this.headers = this.generateHeaders();
      this.items = this.generateItems();
      this.generateFilters();
      this.updateFilter();
      const selectedItems = _.filter(this.items, item =>
        _.some(
          this.currentSelectedFeatures,
          feature => feature.getId() === item.__db_id
        )
      );
      this.ignore = true;
      this.selected = selectedItems;
      this.show = true;
      //this.$forceUpdate();
      
      this.$root.$once('toggleLayerEnd', (key, value) => {
        if (value && key === layer.get("full_type")) {
          setTimeout(() => {
            this.items = this.generateItems();
            this.generateFilters();
            this.updateFilter();
          }, 500);
        }
      });
      this.$root.$emit("toggleLayer", layer.get("full_type"), true);
    },
    closeAttributeTableData() {
      this.layer = false;
      this.filterActive = false;
      this.fields = [];
      this.headers = [];
      this.items = [];
      this.daneFiltra = {};
      this.filtersType = {};

      this.pagination = {
        sortBy: "index",
        rowsPerPage: 100,
        page: 1
      };
      //this._computedWatchers.filtredItems.update();
      this.filtredItems = [];
      this.pagination.totalItems = this.filtredItems.length;
      this._computedWatchers.pages.update();
      this.offsetTop = 0;
      this.editedIndex = -1;
      this.layerNotLoaded = false;
      this.editedItem = {};
      this.show = false;
      //this.$forceUpdate();
    },

    generateHeaders() {
      const headers = [];
      headers.push({
        text: "#",
        align: "left",
        value: "__index",
        type: "integer",
        combo: false,
        comboItems: []
      });
      headers.push({
        text: "ID",
        align: "left",
        value: "__db_id",
        type: "integer",
        combo: false,
        comboItems: []
      });
      _.each(this.fields, field => {
        if ("dictionary" in field) {
          headers.push({
            text: field.display_name,
            align: "left",
            value: field.name,
            type: field.data_type,
            combo: true,
            comboItems: _.map(field.dictionary, v => v.value)
          });
        } else {
          headers.push({
            text: field.display_name,
            align: "left",
            value: field.name,
            type: field.data_type,
            combo: false,
            comboItems: []
          });
        }
      });

      return headers;
    },
    generateItems() {
      const items = [];
      let source = this.layer.getSource();
      if (source instanceof Cluster) {
        source = source.getSource();
      }
      _.each(source.getFeatures(), (feature, index) => {
        const item = {
          __index: index,
          __db_id: feature.getId(),
          __instance: this.$root.createProxy(feature)
        };
        _.each(this.fields, field => {
          if ("dictionary" in field) {
            const dictionary = field.dictionary[feature.get(field.name)] || {};
            item[field.name] = dictionary.value || null;
          } else {
            item[field.name] = feature.get(field.name) || null;
          }
        });
        items.push(item);
      });
      return items;
    },
    generateFilters() {
      this.daneFiltra = {};
      this.filtersType = {};
      _.each(this.headers, header => {
        this.$set(this.daneFiltra, header.value, {});
        this.filtersType[header.value] = header.type;
      });
    },

    calculateExtent() {
      const size = [100, 100];
      const view = this.map.getView();
      const element = this.map
        .getTargetElement()
        .getElementsByClassName("ol-viewport")[0];
      if (element) {
        const metrics = getComputedStyle(element);
        size[0] = parseInt(metrics.width, 10);
        size[1] = parseInt(metrics.height, 10);
      }
      size[1] -= this.$refs.card.$el.offsetHeight;

      //this.map.getView().calculateExtent(size);
      return getForViewAndSize(
        this.map.getCoordinateFromPixel([size[0] / 2, size[1] / 2]),
        view.getResolution(),
        view.getRotation(),
        size
      );
    },

    updateFilter() {
      //this._computedWatchers.filtredItems.update();
      this.filtredItems = this.filterItems();
      this.pagination.totalItems = this.filtredItems.length;
      this._computedWatchers.pages.update();
    },
    convertData(type, value) {
      if (_.isUndefined(value) || _.isNull(value)) {
        return value;
      } else if (type === "datetime" || type === "date") {
        //date
        return moment.utc(value || "").toDate();
      } else if (type === "time") {
        //date
        return moment(value || "", "HH:mm").toDate();
      } else if (type === "integer" || type === "real") {
        //number
        return +value;
      } else {
        return `${value}`;
      }
    },
    filterItems() {
      let items = this.items.slice();

      if (this.filterSelectedActive) {
        items = _.filter(items, item =>
          _.some(this.selected, item_s => item.__db_id === item_s.__db_id)
        );
      }

      if (this.filterExtentActive) {
        const ids = _.map(
          this.layer.getSource().getFeaturesInExtent(this.extent),
          f => f.getId()
        );
        items = _.filter(items, item => _.includes(ids, item.__db_id));
      }

      if (this.filterActive) {
        _.each(this.daneFiltra, (data, column) => {
          if (!_.isEmpty(data)) {
            const value = this.convertData(
              this.filtersType[column],
              data.value
            );
            items = _.filter(items, item =>
              this.filterExecut(
                this.convertData(this.filtersType[column], item[column]),
                data.type,
                value
              )
            );
          }
        });
      }

      return items;
    },
    filterExecut(item, type, value) {
      let negation = false;
      if (_.startsWith(type, "not_")) {
        negation = true;
        type = type.substr(4);
      }

      let result = true;
      switch (type) {
        case "eq":
          result = !value || _.eqSoft(item, value);
          break;
        case "empty":
          result = _.isEmpty(item);
          break;
        case "null":
          result = _.isUndefined(item) || _.isNull(item);
          break;
        case "contains":
          result = !value || _.includes(item, value);
          break;
        case "start_with":
          result = !value || _.startsWith(item, value);
          break;
        case "end_with":
          result = !value || _.endsWith(item, value);
          break;
        case "lt":
          result = _.lt(item, value);
          break;
        case "lte":
          result = _.lte(item, value);
          break;
        case "gt":
          result = _.gt(item, value);
          break;
        case "gte":
          result = _.gte(item, value);
          break;
      }
      return negation ? !result : result;
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.items.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    onResize(e) {
      if (this.filterExtentActive) {
        this.extent = this.calculateExtent();
        this.updateFilter();
      }
    },
    closePanel() {
      this.$root.$emit("closedAttributeTableData");
    },

    editItem(item) {
      this.editedIndex = item.__index;
      //this.editedItem = Object.assign({}, item);
      this.$root.$emit(
        "editAttributesElements",
        [item.__instance],
        this.fields,
        this.layer.get("full_type")
      );
    },
    deleteItem(item) {
      this.editedIndex = item.__index;
      this.$root.$emit("deleteSelectedFeatures", [item.__instance]);

      //this.$delete(this.items, item.__index);
      //this.updateFilter();
    },
    zoomTo(item) {
      this.$root.$emit("zoomToGeometry", item.__instance.getGeometry(), {
        padding: [0, 0, this.$refs.card.$el.offsetHeight, 0]
      });
    },
    editSelectrdItems() {
      this.$root.$emit(
        "editAttributesElements",
        this.currentSelectedFeatures,
        this.fields,
        this.layer.get("full_type")
      );
    },
    clearFilters() {
      this.generateFilters();
    },
    exportItems(event) {
      this._computedWatchers.elementsExport.update();
      if ("pobierz" in this.$refs) {
        this.$refs.pobierz.showExportMenu(event);
      }
    },

    getBaseProps() {
      return (
        _(this.fields)
          .map(field => {
            if ("dictionary" in field) {
              return {
                name: field.name,
                value: _.findKey(
                  field.dictionary,
                  (v, k) => v.value === field.default
                )
              };
            } else if ("model_roughness" === field.name) {
              return {
                name: field.name,
                value: JSON.parse(field.default || "{}").default || null
              };
            } else {
              return {
                name: field.name,
                value: field.default || null
              };
            }
          })
          //.filter((field) => field.value)
          .keyBy("name")
          .mapValues("value")
          .value()
      );
    },
    addNewFeature() {
      let feature = new Feature(this.getBaseProps());

      this.$root.$emit(
        "editAttributesElements",
        [feature],
        this.fields,
        this.layer.get("full_type"),
        "add-single"
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/edition/panels/DataAttributionsTable.vue